import { BaseState } from "./BaseState";
import { StateManager } from "../GameStateManager";
import { EventData } from "../EventData";
import { EventDataEvents, Timings } from "../Consts";
import { EulerEvent } from "@virtuallysports/vs-utils";

// Declare the global variable from script 1 (no longer needed)
// declare var currentEventGlobal: any;

class WarmUpState extends BaseState<StateManager> {
  public id = "WarmUpState"; // A unique identifier for the state
  private checkIntervalId: number | undefined; // Store the interval ID
  private startTime: number; // Store the start time
  private isConnecting: boolean = false; // Flag to prevent multiple connections

  constructor(stateManager: StateManager) {
    super(stateManager); // Pass the StateManager to the base class
    this.bindEvents();
    this.subscribeToEvents();
    this.startTime = 0; // Initialize start time
  }

  public onEnter(stateManager: StateManager): void {
    this.stateManager = stateManager;
    super.onEnter(stateManager); // Call the super method
    this.stateManager.enteredWarmUpState();

    this.startTime = Date.now(); // Record the time when the state is entered

    
    // Start fetching arrival data immediately
    this.fetchArrivalData();
  }

  private bindEvents() {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents() {
    const eventData = EventData.getInstance();
    eventData.subscribeToEvent(
      EventDataEvents.ON_ARRIVAL_ORDER_ASSIGNED,
      this.transition,
    );
  }

  public transition(): void {
    console.log("Transitioning to PreRaceState from WarmUpState");
    this.stateManager?.changeState(this.stateManager.preRaceState);
  }

 

  private async fetchArrivalData(): Promise<void> {
    if (this.isConnecting) {
      return; // Already connecting, don't start another connection
    }
    
    this.isConnecting = true;
    
    try {
      // First, get the current event ID from the API
      const eventResponse = await fetch('https://api.test-euler-frontend.com/api/v1/event/current/61/1');
      
      if (!eventResponse.ok) {
        throw new Error('Failed to fetch current event');
      }
      
      const eventData = await eventResponse.json();
      
      // Get the first (and likely only) event from the response
      const eventId = Object.keys(eventData)[0];
      
      if (!eventId) {
        console.error('No current event found');
        window.location.reload();
        return;
      }
      
      console.log('Found event ID:', eventId);
      
      // Now connect to the WebSocket with the event ID
      const ws = new WebSocket(`wss://ws.test-euler-frontend.com/api/v1/gamesocket/1/${eventId}`);

      ws.onopen = () => {
        console.log('WebSocket connection established for event:', eventId);
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          
          if (data.results && data.results.arrival && data.results.arrival.length > 0) {
            const arrivalData = data.results.arrival;
            console.log('Received arrival data:', arrivalData);
            
            // Process the arrival data and transition
            this.processArrivalData(data);
            
            // Close the WebSocket connection
            ws.close();
          }
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
          ws.close();
          this.isConnecting = false; // Reset flag on error
        }
      };

      ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        this.isConnecting = false; // Reset flag on error
        // Fallback to reload if WebSocket fails
        window.location.reload();
      };

      ws.onclose = () => {
        console.log('WebSocket connection closed');
        this.isConnecting = false; // Reset flag when connection closes
      };

      // Set a timeout to close the connection after 10 seconds
      setTimeout(() => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.close();
        }
      }, 10000); // 10 second timeout
      
    } catch (error) {
      console.error('Error fetching event data:', error);
      this.isConnecting = false; // Reset flag on error
      window.location.reload(); // Fallback to reload
    }
  }

  private processArrivalData(data: EulerEvent): void {
    console.log('Processing arrival data:', data);
    EventData.getInstance().processArrivalOrderBackup(data);
    
    // Call transition after successfully receiving data
   // this.transition();
  }

  public onExit(): void {
    super.onExit();

    // Clear the interval when exiting the state
    if (this.checkIntervalId !== undefined) {
      window.clearInterval(this.checkIntervalId);
      this.checkIntervalId = undefined;
    }
  }
}

export { WarmUpState };